const findInput = (element) =>
  element.matches("input")
    ? element
    : element.querySelector(".input-tel__input, input:not([readonly])");

const allowedKeys = new Set([
  "Backspace", "Delete", "Tab", "Enter", "Escape",
  "ArrowLeft", "ArrowRight", "ArrowUp", "ArrowDown", "Home", "End",
]);

export default {
  inserted(element) {
    const input = findInput(element);
    if (!input) return;

    const onKeydown = (event) => {
      if (
        event.ctrlKey || event.metaKey || allowedKeys.has(event.key) ||
        /^\d$/.test(event.key)
      ) return;
      if (event.key.length === 1) event.preventDefault();
    };
    const onBeforeInput = (event) => {
      if (event.data && /\D/.test(event.data)) event.preventDefault();
    };
    const onInput = (event) => {
      const digits = event.target.value.replace(/\D/g, "");
      if (digits !== event.target.value) event.target.value = digits;
    };

    input.setAttribute("inputmode", "numeric");
    input.addEventListener("keydown", onKeydown);
    input.addEventListener("beforeinput", onBeforeInput);
    input.addEventListener("input", onInput, true);
    element.__digitsOnly = { input, onKeydown, onBeforeInput, onInput };
  },
  unbind(element) {
    const listeners = element.__digitsOnly;
    if (!listeners) return;
    listeners.input.removeEventListener("keydown", listeners.onKeydown);
    listeners.input.removeEventListener("beforeinput", listeners.onBeforeInput);
    listeners.input.removeEventListener("input", listeners.onInput, true);
    delete element.__digitsOnly;
  },
};
